import { Modal, Space, Typography } from 'antd';
import React, { useState } from 'react';

import { EHotkey, HOTKEYS, useHotkey } from '../hooks/use-hotkey';
import { SPACING } from '../theme/tokens';

export function HotkeyList({
  hotkeys,
}: {
  hotkeys: EHotkey[];
}): React.ReactElement {
  return (
    <Space orientation="vertical" size={SPACING.xs}>
      {hotkeys.map((hotkey: EHotkey): React.ReactElement => (
        <div key={hotkey}>
          <Typography.Text keyboard>{HOTKEYS[hotkey].label}</Typography.Text>{' '}
          {HOTKEYS[hotkey].description}
        </div>
      ))}
    </Space>
  );
}

function KeyboardShortcutsHelp(): React.ReactElement {
  const [isOpen, setIsOpen] = useState(false);

  useHotkey([EHotkey.SHOW_HELP], (): void => {
    setIsOpen(true);
  });

  return (
    <Modal
      title="Keyboard shortcuts"
      open={isOpen}
      footer={null}
      onCancel={(): void => {
        setIsOpen(false);
      }}
    >
      <HotkeyList hotkeys={Object.values(EHotkey)} />
    </Modal>
  );
}

export default KeyboardShortcutsHelp;
